import type { LessonRoomStore } from './interfaces'

export const getters = {
  getBooking: (state: LessonRoomStore): LessonRoomStore['booking'] => state.booking,
  isLastLesson: (state: LessonRoomStore): boolean => state.lastLesson,
  isChatOpen: (state: LessonRoomStore): boolean => state.activeOverlay === 'chat',
  hasChatUnread: (state: LessonRoomStore): boolean => state.chatUnread,
  getChatMessages: (state: LessonRoomStore): LessonRoomStore['chatMessages'] => state.chatMessages,
  isSettingsOpen: (state: LessonRoomStore): boolean => state.activeOverlay === 'settings',
  isPermissionsBlocked: (state: LessonRoomStore): boolean => state.permissionsBlocked,
  isDeniedMic: (state: LessonRoomStore): boolean => state.deniedMic,
  isDeniedCam: (state: LessonRoomStore): boolean => state.deniedCam,
  isGuideOpen: (state: LessonRoomStore): boolean => state.activeOverlay === 'guide',
  getGuideCategory: (state: LessonRoomStore): LessonRoomStore['guideCategory'] => state.guideCategory,
}
